var LightBoots = function (quality) {
  return {
    slot: 'boots',
    type: 'light',
    quality: quality,
    armorClass: Math.round(3 + quality * 16),
    magicalGravity: quality * 2,
  };
};
module.exports = LightBoots;
